<template>
    <div>
        <div :class="state == 0 ? 'no_data' : 'no_network' ">
            <img class="tips_img" :src="data[state].photoUrl"  alt='版权登记'>
            <p class="tips_text">{{ data[state].tipsText }}</p>
        </div>
    </div>

</template>

<script>
    export default {
        name: "error-tips",
        props: {
            state: {
                type: Number,
                default: 0,
            }
        },
        data() {
            return {
                data: [
                    {photoUrl: require('@/assets/empty.png'), tipsText: '表单暂无数据哦～'},
                    {photoUrl: require('@/assets/no_network.png'), tipsText: '找不到网络～'},
                ]
            }
        },
        created() {
        }
    }
</script>

<style scoped lang="less">
    .no_data {
        text-align: center;
        padding: 75px;
        margin: auto;

        .tips_img {
            width: 300px;
            height: 181px;
            display: inline-block;
        }

        .tips_text {
            color: #666;
            font-size: 14px;
            text-align: center;
            padding-top: 7px;
            margin-left: -160px;
        }

    }

    .no_network {
        width: 170px;
        text-align: center;
        margin: 0 auto;

        .tips_img {
            width: 170px;
            height: 175px;
            display: inline-block;
        }

        .tips_text {
            color: #666;
            font-size: 14px;
            padding-top: 28px;
        }
    }
</style>